export const nabisDomains: string[] = ['nabis.com', 'getnabis.com'];

export const isNabisUser = (email: string): boolean => {
  if (!email.length) {
    return false;
  }

  const isEmail = email.search('@') !== -1;
  if (!isEmail) {
    return false;
  }

  const emailDomain = email.split('@')[1];
  return nabisDomains.includes(emailDomain.toLowerCase());
};
